import {useSearchParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import {Template} from "../../../components/template/template.jsx";
import TemplateHeader from "../../../components/template/template-header.jsx";
import TemplateBody from "../../../components/template/template-body.jsx";
import TemplateTitle from "../../../components/template/template-title.jsx";
import React, {useEffect, useRef, useState} from "react";
import contactIdService from "../../../services/web/contact-id-service.js";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import PrintTemplate from "../../../components/reports/print-reports/print-template.jsx";
import CardBody from "../../../components/card/card-body.jsx";
import {Card} from "../../../components/card/card.jsx";
import clsx from "clsx";

const formatSectorAndUserName = (item) => {
  const description = item.data.nameDescription ?? "";
  const codeZone = item?.data?.codUserZone ?? ""
  if(description && codeZone) return description + " - " + codeZone;
  if(description) return description;
  if(codeZone) return codeZone;
  return ""
}

const buildPayload = ({id, type, user, dtStart, dtEnd, fireAlarm}) => {
  const payload =  {
    id,
    type: type,
    username_ack: user,
    dtStart,
    dtEnd
  }

  if(fireAlarm) payload.fireAlarm = fireAlarm;

  return payload
}

const normalTableLabel = [
  "D/H do evento",
  "Evento",
  "Setor/Nome do usuário",
  "Quem aceitou",
  "Observação"
]

const fireAlarmTableLabel = [
  "D/H do evento",
  "Evento",
  "Zona | Loop | Dispositivo"
]

const buildNormalTable = (data) => {
  return (
    <table className="table report-table mt-[25px] print:mt-[0]">
      <thead className="thead-background print:table-row-group!">
      <tr className="bg-[#f6f6f6] text-left">
        <th className="w-[15%]">{normalTableLabel[0]}</th>
        <th className="w-[15%]">{normalTableLabel[1]}</th>
        <th className="w-[20%]">{normalTableLabel[2]}</th>
        <th className="w-[15%]">{normalTableLabel[3]}</th>
        <th className="w-[35%]">{normalTableLabel[4]}</th>
      </tr>
      </thead>
      <tbody>
      {data?.list.map((item, index) => {
        const message = item.message?.replace(/"/g, "").trim();
        return(
          <React.Fragment key={index}>
            <tr className={`table-break-word`}>
              <td>{item.date}</td>
              <td className={clsx({"font-bold! text-[#f8ac59]!": message === "Offline"},
                {"font-bold! text-[#dc3545]!": message === "Disparo De Alarme"})}>{message}</td>
              <td>{formatSectorAndUserName(item)}</td>
              <td>{item.username_ack ?? "Pendente"}</td>
              <td>{item.observation}</td>
            </tr>
          </React.Fragment>
        )
      })}
      </tbody>
    </table>
  )
}
const buildFireAlarmTable = (data) => {
  return (
    <table className="table report-table mt-[25px] print:mt-[0]">
      <thead className="thead-background print:table-row-group!">
      <tr className="bg-[#f6f6f6] text-left">
        <th className="w-[15%]">{fireAlarmTableLabel[0]}</th>
        <th className="w-[15%]">{fireAlarmTableLabel[1]}</th>
        <th className="w-[20%]">{fireAlarmTableLabel[2]}</th>
      </tr>
      </thead>
      <tbody>
      {data?.list.map((item, index) => {
        const message = item.message?.replace(/"/g, "").trim();
        return(
          <React.Fragment key={index}>
            <tr className={`table-break-word`}>
              <td>{item.date ?? ""}</td>
              <td className={clsx({"font-bold! text-[#f8ac59]!": message === "Offline"},
                {"font-bold! text-[#dc3545]!": message === "Disparo De Alarme"})}>{message}</td>
              <td>{item.zone ?? ""}</td>
            </tr>
          </React.Fragment>
        )
      })}
      </tbody>
    </table>
  )
}
const ContactId = () => {
  const [headerSelected, setHeaderSelected] = useState(-1);
  const [isPrinting, setIsPrinting] = useState(false);
  const printComponentRef = useRef(null);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("contactid");
  const type = searchParams.get("type")
    ? searchParams.get("type").split(",")
    : null;
  const user = searchParams.get("user")
    ? searchParams.get("user").split(",")
    : null;
  const dtStart = searchParams.get("dtinitial") || '';
  const dtEnd = searchParams.get("dtfinal") || '';
  const fireAlarm = searchParams.has("fireAlarm");

  const {data = null, isLoading} = useQuery({
    queryFn: () => contactIdService.apply(buildPayload({id, type, user, dtStart, dtEnd, fireAlarm})),
    enabled: !!id,
    queryKey: ["data"],
    select: data => {
      const tempData = {...data};
      tempData.list.sort((a, b) => new Date(b.dt_event).getTime() - new Date(a.dt_event).getTime());
      return tempData;
    },
    staleTime: 0,
  })

  return(
     <Template isLoading={isLoading || isPrinting}>
       <TemplateHeader>
         <div className="flex justify-between w-full">
           <TemplateTitle>Evento patrimonial {data && data?.name ? ` - ${data.name}` : ""}</TemplateTitle>
           <HeaderButtons
             exportable={false}
             exportInSheets={false}
             printable={true}
             headerChange={true}
             printComponentRef={printComponentRef}
             reportData={data}
             data={data?.list.length}
             headerSelected={headerSelected}
             setHeaderSelected={setHeaderSelected}
             setCollapsed={() => {}}
           />
         </div>
       </TemplateHeader>
       <TemplateBody>
          <Card>
            <CardBody>
              <PrintTemplate
                title={data && data?.name ? "EVENTO PATRIMONIAL " + data.name : ""}
                entity={headerSelected}
                ref={printComponentRef}
                setIsPrinting={setIsPrinting}
              >
                {
                  fireAlarm
                    ? buildFireAlarmTable(data)
                    : buildNormalTable(data)
                }
                <div id="chart-tables"></div>
              </PrintTemplate>
            </CardBody>
          </Card>
       </TemplateBody>
     </Template>
  )
}

export default ContactId;